import React from 'react';
import styles from './index.module.scss';

const Card: React.FunctionComponent<CardProps> = (props) => {
  const { children, className, style, role, tabIndex } = props;

  return (
    <div className={className} style={style} role={role} tabIndex={tabIndex}>
      {children}
    </div>
  );
};

Card.defaultProps = {
  className: styles.card,
  style: {},
  role: '',
  tabIndex: 0,
};

interface CardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  role?: string;
  tabIndex?: number;
}

export default Card;
